<template>
  <div>
    <form novalidate class="md-layout" @submit.prevent="validateProfile">
      <md-card class="no-shadow md-layout-item md-size-100">
        <md-card-header>
          <div class="md-title"></div>
        </md-card-header>

        <md-card-content>

          <div>
            <avatar
              :src="currentUser.avatar"
              :editable="true"
              width="150px"
              height="150px"
            />
          </div>
          <br>

          <md-field :class="getValidationClass('firstname')">
            <label for="firstname">Firstname</label>
            <md-input type="text" name="firstname" id="firstname" autocomplete="firstname" v-model="form.firstname" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.firstname.required">The firstname is required</span>
            <span class="md-error" v-else-if="!$v.form.firstname.firstname">Invalid firstname</span>
          </md-field>

          <md-field :class="getValidationClass('lastname')">
            <label for="lastname">Lastname</label>
            <md-input type="text" name="lastname" id="lastname" autocomplete="lastname" v-model="form.lastname" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.lastname.required">The lastname is required</span>
            <span class="md-error" v-else-if="!$v.form.lastname.lastname">Invalid lastname</span>
          </md-field>

          <error-container :error="error"></error-container>

        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button
            type="submit"
            class="md-raised md-primary"
            :disabled="sending"
          >
            Update Profile
          </md-button>
        </md-card-actions>
      </md-card>

      <md-snackbar :md-active.sync="profileUpdated">Your profile was successfully updated!</md-snackbar>
    </form>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import Avatar from '../Avatar'
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'
export default {
  name: 'SettingsProfileForm',
  mixins: [validationMixin],
  components: {
    ErrorContainer,
    Avatar
  },
  mounted () {
    this.form.firstname = this.currentUser.firstname
    this.form.lastname = this.currentUser.lastname
  },
  data: () => ({
    form: {
      firstname: null,
      lastname: null
    },
    profileUpdated: false,
    sending: false,
    lastUser: null,
    error: null
  }),
  validations: {
    form: {
      firstname: {
        required
      },
      lastname: {
        required
      }
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters['me']
    },
    updatedUser () {
      let updatedUser = JSON.parse(JSON.stringify(this.currentUser))
      updatedUser.firstname = this.form.firstname
      updatedUser.lastname = this.form.lastname
      return updatedUser
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.email = null
      this.form.firstname = null
      this.form.lastname = null
      this.form.password = null
    },
    async saveProfileSettings () {
      this.sending = true
      try {
        await this.$store.dispatch('updateSettingsUserProfile', this.updatedUser)
        this.profileUpdated = true
      } catch (error) {
        this.error = error
      } finally {
        this.sending = false
      }
    },
    validateProfile () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saveProfileSettings()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .md-progress-bar {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
  }
  .no-shadow  {
    box-shadow: none;
  }
  .md-title {
    text-align: left;
  }
  .md-card-content {
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/SettingsProfileForm.vue